import { useGetCbtMonitoringSignalingTokenMutation } from '@/types/vue-apollo-helpers';
import { CbtMonitoringSignalingRoleEnum } from '@/types/composition-functions';
import type { SignalingRole } from '../types';

export function useSignalingToken() {
  const { mutate, loading, error } = useGetCbtMonitoringSignalingTokenMutation();

  const issue = async(monitoringSessionId: string, role: SignalingRole) => {
    const enumRole =
      role === 'producer'
        ? CbtMonitoringSignalingRoleEnum.Producer
        : CbtMonitoringSignalingRoleEnum.Consumer;

    const result = await mutate({
      monitoring_session_id: monitoringSessionId,
      role: enumRole,
    });

    const data = result?.data?.getCbtMonitoringSignalingToken;
    if (!data) throw new Error('Failed to issue signaling token');
    return data;
  };

  return { issue, loading, error };
}
